import * as Yup from 'yup'

import { mensagemPadrao } from '../../../../../../dados-estaticos'

export const schema = Yup.object().shape({
  grade: Yup.string().required(mensagemPadrao)
})
